module.exports = {"modifyPassword":"修改密码","expand":"展开","collapse":"收起"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/locales/zh-CN/qidian.json
// module id = bd5n
// module chunks = 1